module.exports = __webpack_public_path__ + "static/media/why_bg.0d9263ad.png";